"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_AREA_RISERVATA_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.widgetAreaRiservata,
    skipImportingInCMS: false,
}, {
    tpdDatiPersonaliWidget: {
        __mfeName__: "tpdDatiPersonaliWidget",
        devClientPort: 6069,
        devServerPort: 6169,
    },
    tpdPrivacyBannerWidget: {
        __mfeName__: "tpdPrivacyBannerWidget",
        devClientPort: 6071,
        devServerPort: 6171,
    },
    tpdPrivacyPageWidget: {
        __mfeName__: "tpdPrivacyPageWidget",
        devClientPort: 6072,
        devServerPort: 6172,
    },
    tpdPresentazioneAgenziaWidget: {
        __mfeName__: "tpdPresentazioneAgenziaWidget",
        devClientPort: 6301,
        devServerPort: 6401,
    },
    tpdEsitoRinnovoPolizzaWidget: {
        __mfeName__: "tpdEsitoRinnovoPolizzaWidget",
        devClientPort: 6092,
        devServerPort: 6192,
    },
    tpdPagamentoRinnovoPolizzaWidget: {
        __mfeName__: "tpdPagamentoRinnovoPolizzaWidget",
        devClientPort: 6093,
        devServerPort: 6193,
    },
    tpdInformativaRinnovoPolizzaWidget: {
        __mfeName__: "tpdInformativaRinnovoPolizzaWidget",
        devClientPort: 6094,
        devServerPort: 6194,
    },
    tpdDettaglioPolizzaCollettivaWidget: {
        __mfeName__: "tpdDettaglioPolizzaCollettivaWidget",
        devClientPort: 6084,
        devServerPort: 6184,
    },
    tpdDettaglioPolizzaPrevidenzaWidget: {
        __mfeName__: "tpdDettaglioPolizzaPrevidenzaWidget",
        devClientPort: 6086,
        devServerPort: 6186,
    },
    tpdDettaglioPolizzaRamiElementariWidget: {
        __mfeName__: "tpdDettaglioPolizzaRamiElementariWidget",
        devClientPort: 6082,
        devServerPort: 6182,
    },
    tpdSubmenu: {
        __mfeName__: "tpdSubmenu",
        devClientPort: 6028,
        devServerPort: 6128,
        mfePriority: 2000,
    },
    tpdDispositiviTelematici: {
        __mfeName__: "tpdDispositiviTelematici",
        devClientPort: 6099,
        devServerPort: 6199,
    },
    tpdAcquistoWidget: {
        __mfeName__: "tpdAcquistoWidget",
        devClientPort: 6303,
        devServerPort: 6403,
    },
    tpdDocumentazioneWidget: {
        __mfeName__: "tpdDocumentazioneWidget",
        devClientPort: 6304,
        devServerPort: 6404,
    },
    tpdSpedizionePolizzaWidget: {
        __mfeName__: "tpdSpedizionePolizzaWidget",
        devClientPort: 6305,
        devServerPort: 6405,
    },
    tpdEsitoAcquistoWidget: {
        __mfeName__: "tpdEsitoAcquistoWidget",
        devClientPort: 6306,
        devServerPort: 6406,
    },
    tpdInserimentoPinWidget: {
        __mfeName__: "tpdInserimentoPinWidget",
        devClientPort: 6321,
        devServerPort: 6421,
    },
    tpdNotificheAreaRiservataWidget: {
        __mfeName__: "tpdNotificheAreaRiservataWidget",
        devClientPort: 6328,
        devServerPort: 6428,
        mfePriority: 1000,
    },
    tpdEsitoAggiuntaCartaWidget: {
        __mfeName__: "tpdEsitoAggiuntaCartaWidget",
        devClientPort: 6329,
        devServerPort: 6429,
    },
});
exports.WIDGET_AREA_RISERVATA_REMOTES_SETTINGS = settings;
